import React from "react";
import { useSelector, useDispatch } from "types/store";
import * as viewReducer from "containers/View/reducer";
import { isEnabled } from "utils/featureFlags";
import LabeledToggle from "components/Inputs/Toggle/Toggle";
import styles from "./style.module.css";
const AgentSimpleAnalyticsToggle = ({ disableButtons }) => {
    const dispatch = useDispatch();
    const agentSimpleAnalyticsView = useSelector((state) => viewReducer.getAgentSimpleAnalyticsView(state));
    const updateAgentSimpleAnalyticsView = (val) => dispatch(viewReducer.updateAgentSimpleAnalyticsView(val));
    if (!isEnabled("agent-simple-analytics")) {
        return null;
    }
    return (React.createElement("div", { className: styles.settingFlex },
        React.createElement("div", null, "Use Agent Simple Analytics Mode"),
        React.createElement(LabeledToggle, { style: { display: "block" }, checked: agentSimpleAnalyticsView, onChange: () => {
                updateAgentSimpleAnalyticsView(!agentSimpleAnalyticsView);
            }, disabled: disableButtons, isAibleColors: true })));
};
export default AgentSimpleAnalyticsToggle;
